module.exports = __webpack_public_path__ + "img/Andrej Berlin.94724d27.jpg";